import React from 'react';
import {
  FlexRow,
  P,
  Span,
  VisuallyHidden,
} from 'common/styles/oc-styled-components';

import { colors } from 'common/styles/style-constants';
import PropTypes from 'prop-types';

import {
  Link,
  StyledLock,
} from '../../../legacy-checkout/checkout-styled-components';

const TERMS_URL = `${CONFIG.SEARCH_APP_URL}/terms/sms`;
export const PRIVACY_URL = `${CONFIG.SEARCH_APP_URL}/privacy`;

const TermsAndConditions = ({ withoutPhone }) => (
  <>
    <FlexRow>
      <StyledLock aria-hidden margin="2px 0 0 0" theme="filled" type="lock" />
      <div>
        {withoutPhone === true
          ? (
            <VisuallyHidden>
              By continuing, you agree to receive emails from Opencare, and agree
              to our Terms and Privacy Policy. Message frequency varies. Message &
              data rates may apply.
            </VisuallyHidden>
          )
          : (
            <VisuallyHidden>
              By continuing, you agree to receive text messages from Opencare, and
              agree to our Terms and Privacy Policy. Message frequency varies.
              Message & data rates may apply.
            </VisuallyHidden>
          )
        }
        <P
          margin="0 0 0 8px"
          fontSize="12px"
          color={colors.slate}
          letterSpacing="-0.015em"
        >
          {withoutPhone === true
            ? (
              <span aria-hidden>
                By continuing, you agree to receive emails from Opencare, and
                agree to our{' '}
              </span>
            )
            : (
              <span aria-hidden>
                By continuing, you agree to receive text messages from Opencare,
                and agree to our{' '}
              </span>
            )
          }
          <Link href={TERMS_URL} target="_blank">
            Terms
          </Link>
          <span aria-hidden> and </span>
          <Link href={PRIVACY_URL} target="_blank">
            Privacy Policy
          </Link>
          {withoutPhone === true
            ? <span aria-hidden>.</span>
            : (
              <span aria-hidden>
                . Msg frequency varies. Msg & data rates may apply.
              </span>
            )
          }
        </P>
      </div>
    </FlexRow>
    {withoutPhone !== true 
      && (
        <FlexRow margin="15px 0 0 0">
          <StyledLock aria-hidden margin="2px 0 0 0" theme="filled" type="bell" />
          <div>
            <VisuallyHidden>
              Text STOP to opt out or HELP for help.
            </VisuallyHidden>
            <P
              color={colors.slate}
              fontSize="12px"
              margin="0 0 0 3px"
              letterSpacing="-0.015em"
              aria-hidden
            >
              Text <Span fontWeight="600">STOP</Span> to opt out or{' '}
              <Span fontWeight="600">HELP</Span> for help.
            </P>
          </div>
        </FlexRow>
      )
    }
  </>
);

TermsAndConditions.propTypes = {
  withoutPhone: PropTypes.bool,
};

export default TermsAndConditions;
